{
  "allergens": {
    "CELERY": "Целина",
    "clearAll": "Изчистване",
    "CRUSTACEANS": "Ракообразни",
    "EGGS": "Яйца",
    "FISH": "Риба",
    "GLUTEN": "Глутен",
    "LUPIN": "Лупина",
    "MILK": "Лактоза",
    "MOLLUSCS": "Мекотели",
    "MUSTARD": "Синап",
    "none": "Няма",
    "PEANUTS": "Фъстъци",
    "SESAME": "Сусам",
    "SOYBEANS": "Соя",
    "SULPHITES": "Сулфити",
    "title": "Алергени",
    "TREE_NUTS": "Ядки"
  },
  "auth": {
    "alreadySignedIn": "Вече сте влезли в профила си като {{currentName}} (<currentMailto>{{currentEmail}}</currentMailto>). Излезте, за да създадете нов профил с имейл <newMailto>{{newEmail}}</newMailto>.",
    "alreadySignedInTitle": "Вече сте влезли",
    "backToHome": "Към началната страница",
    "cannotJoinAccountExists": "За Вашия имейл адрес <inviteeMailto>{{inviteeEmail}}</inviteeMailto> вече има профил. Моля, поискайте от {{inviterName}} (<inviterMailto>{{inviterEmail}}</inviterMailto>) да Ви покани с друг имейл адрес.",
    "cannotJoinTeamTitle": "Присъединяването е невъзможно",
    "completeSignup": "Довършване на профила",
    "completeSignupSubtitle": "Кажете ни името си и сте готови.",
    "continueButton": "Продължаване",
    "invitedBy": "{{name}} Ви кани да се присъедините към своя екип в Calculabel.",
    "invitedByEmail": "{{name}} ({{email}}) Ви кани да се присъедините към своя екип.",
    "linkInvalidSubtitle": "Този линк за вход е изтекъл или вече е използван. Поискайте нов.",
    "linkInvalidTitle": "Линкът вече не работи",
    "namePlaceholder": "Вашето пълно име",
    "requestNewLink": "Поискване на нов линк",
    "signingIn": "Вход…"
  },
  "billing": {
    "adminOnly": "Само администраторите на екипа могат да управляват плащанията.",
    "cancelScheduledBare": "Платеният план на екипа ще изтече в края на платения период. Подновете го от портала за плащане, за да продължите редактирането.",
    "cancelScheduledBody": "Платеният план на екипа изтича на {{date}}. Подновете го от портала за плащане, за да продължите редактирането.",
    "cancelScheduledTitle": "Планирано прекратяване на плана",
    "checkoutSuccessBody": "Плащането премина успешно. Вече можете да ползвате Calculabel без ограничения.",
    "checkoutSuccessTitle": "Абонаментът е активиран",
    "currentPeriodEnd": "Следващо плащане",
    "freeAccessUntil": "Безплатен достъп до",
    "lockedAdmin": "Моля, изберете подходящ абонаментен план, за да продължите да редактирате рецепти, съставки и производители.",
    "lockedMember": "Помолете администратора на екипа да добави начин на плащане, за да продължите редактирането.",
    "lockedTitle": "Безплатният достъп изтече",
    "manageBilling": "Управление на абонамента и фактури",
    "openSubscription": "Към абонамента",
    "pastDueAdmin": "Последното ви плащане е неуспешно. Актуализирайте начина си на плащане, за да продължите този абонамент.",
    "pastDueMember": "Последното ви плащане за услугата е неуспешно. Помолете администратора да актуализира начина на плащане.",
    "pastDueTitle": "Проблем с плащането",
    "sectionManage": "Управление на абонамента",
    "sectionStatus": "Текущо състояние",
    "sectionSubscribe": "Създаване на абонамент",
    "statusActive": "Активен",
    "statusCanceled": "Прекратен",
    "statusIncomplete": "Незавършен",
    "statusIncompleteExpired": "Незавършен (изтекъл)",
    "statusNone": "Без абонамент",
    "statusPastDue": "Просрочено плащане",
    "statusPaused": "На пауза",
    "statusTrialing": "Пробен период",
    "statusUnpaid": "Неплатен",
    "stripeNote": "Calculabel използва Stripe за сигурна обработка на плащанията и управление на абонаментите. Данните на Вашата карта се съхраняват и обработват от Stripe — те никога не достигат до нашите сървъри. Историята на плащанията и фактурите са достъпни в портала на Stripe.",
    "subscribe": "Абониране",
    "subscriptionEndedOn": "Прекратен на",
    "subscriptionStatus": "Състояние на абонамента",
    "subscriptionWillEndOn": "Активен до",
    "tabTitle": "Абонамент",
    "trialDaysLeft_one": "Остава {{count}} ден безплатен достъп — изтича на {{date}}.",
    "trialDaysLeft_other": "Остават {{count}} дни безплатен достъп — изтича на {{date}}.",
    "trialEndingSoonTitle": "Безплатният достъп изтича скоро",
    "trialEndingTitle": "Безплатният достъп изтича"
  },
  "caseToggle": {
    "lowerCase": "малки букви",
    "sentenceCase": "Начало на изречение",
    "titleCase": "Начало На Дума",
    "upperCase": "ГЛАВНИ БУКВИ"
  },
  "common": {
    "back": "Назад",
    "cancel": "Отказ",
    "create": "Създаване",
    "createdBy": "Създадено от",
    "editName": "Редактиране на {{name}}",
    "email": "Имейл",
    "legal": "Юридическа информация",
    "name": "Пълно име",
    "privacy": "Политика за поверителност",
    "save": "Запазване",
    "terms": "Условия за ползване"
  },
  "error": {
    "application-error": {
      "description": "Нещо се обърка. Моля, опитайте отново или презаредете страницата.",
      "title": "Възникна грешка"
    },
    "auth": {
      "email-link-expired": "Този линк за вход е изтекъл. Поискайте нов.",
      "email-link-not-found": "Този линк за вход е невалиден.",
      "email-link-used": "Този линк за вход вече е използван.",
      "not-authenticated": "Трябва да сте влезли в профила си, за да извършите това действие.",
      "not-authorized": "Нямате разрешение да извършите това действие.",
      "signup-name-required": "Моля, въведете името си, за да довършите регистрацията."
    },
    "ingredient": {
      "deleted": "Тази съставка е изтрита и не може да се променя.",
      "not-found": "Съставката не е намерена.",
      "price-invalid": "Невалидна цена: количеството трябва да е положително, а цената и ставката на ДДС не могат да бъдат отрицателни.",
      "price-unit-not-weight": "Цената може да се въвежда само в тегловни мерни единици."
    },
    "network-error": {
      "description": "Не може да се свърже със сървъра. Проверете връзката си.",
      "title": "Мрежова грешка"
    },
    "producer": {
      "deleted": "Този производител е изтрит и не може да се променя.",
      "not-found": "Производителят не е намерен."
    },
    "recipe": {
      "circular-dependency": "Добавянето на тази рецепта би създало кръгова зависимост — избраната рецепта вече зависи от текущата.",
      "circular-self-reference": "Рецепта не може да съдържа себе си като съставка.",
      "deleted": "Тази рецепта е изтрита и не може да се променя.",
      "not-found": "Рецептата не е намерена.",
      "not-published": "Тази рецепта няма публикувана версия, която да бъде дублирана."
    },
    "subscription": {
      "access-locked": "Безплатният достъп на екипа изтече. Добавете начин на плащане, за да продължите да редактирате.",
      "no-customer": "Този екип все още няма платежен профил.",
      "stripe-unavailable": "Плащанията временно не са налични. Моля, опитайте отново след малко."
    },
    "team": {
      "cannot-join-account-exists": "За този имейл адрес вече има профил.",
      "cannot-remove-last-admin": "Екипът трябва да има поне един администратор.",
      "invitation-already-exists": "Вече има активна покана за този имейл. Отменете я, ако искате да изпратите нова.",
      "invitation-email-undeliverable": "Този имейл адрес не може да бъде достигнат — проверете правописа и опитайте отново.",
      "invitation-not-found": "Линкът за покана е невалиден.",
      "member-not-found": "Членът на екипа не е намерен.",
      "not-found": "Екипът не е намерен.",
      "settings-invalid": "Невалиден код на валута или държава."
    },
    "unknown": "Възникна неочаквана грешка."
  },
  "g": {
    "actions": "Действия",
    "reload": "Презареждане",
    "saving": "Запазване…",
    "savingError": "Грешка при запис — натиснете за повторен опит",
    "searching": "Търсене…"
  },
  "ingredients": {
    "actions": "Действия",
    "allergens": "Алергени",
    "allergensHelp": "Допълнителни алергени, които не са част от съставките, но желаете да декларирате",
    "allergensPlaceholder": "Изберете алергени…",
    "archivedVersionBannerAction": "Вижте актуалната съставка",
    "archivedVersionBannerText": "Това е стар вариант на тази съставка.",
    "brand": "Марка",
    "comparePhotos": {
      "drawerTitle": "Снимки на етикета",
      "open": "Сравни със снимките на етикета"
    },
    "continueEditing": "Продължаване на редактиране",
    "createChoice": {
      "fromGeneric": "От основни храни",
      "fromGenericDesc": "Търсете в базата данни за хранителни стойности",
      "fromLabel": "От етикета на продукта",
      "fromLabelDesc": "Снимайте етикета и ще създадем съставката от него",
      "manual": "Ръчно създаване",
      "manualDesc": "Въведете всички данни сами",
      "newFromLabel": "Нова съставка",
      "uploadHint": "Качете, поставете или направете снимка на етикета на продукта"
    },
    "createdAt": "Създадена",
    "createIngredient": "Нова съставка",
    "delete": "Изтриване",
    "deleteConfirm": "Сигурни ли сте, че искате да изтриете тази съставка?",
    "deletedBanner": "Тази съставка е изтрита.",
    "deletedDone": "Съставката е изтрита",
    "deleteTitle": "Изтриване на съставка",
    "description": "Описание",
    "discardDraft": "Отхвърляне",
    "discardDraftConfirm": "Сигурни ли сте, че искате да отхвърлите направените промени?",
    "discardDraftTitle": "Отхвърляне на промени",
    "draftBannerText": "Тази съставка има непубликувани промени.",
    "edit": "Редактиране",
    "labelIngredients": {
      "add": "Добавяне на съставка",
      "addAfter": "Добавяне на още една",
      "addChild": "Добавяне на подсъставка",
      "allergensPrefix": "Алергени:",
      "delete": "Изтриване",
      "deleteConfirm": "Сигурни ли сте, че искате да изтриете тази съставка и всички нейни подсъставки?",
      "deleteTitle": "Изтриване на съставка",
      "emailPrefix": "имейл: ",
      "ingredientsPrefix": "Съставки:",
      "nameColumn": "Съставки",
      "namePlaceholder": "Име на съставката…",
      "noIngredients": "Все още няма съставки за етикет",
      "phonePrefix": "тел. ",
      "producerPrefix": "Производител:",
      "recognize": "Разпознаване на етикет",
      "recognizeConfirm": "Сигурни ли сте? Името, описанието, съставките и енергийните стойности ще бъдат презаписани от разпознаването на етикета.",
      "recognizeConfirmTitle": "Разпознаване на етикет",
      "websitePrefix": "уеб: "
    },
    "name": "Име",
    "nameForLabel": "Име за етикет",
    "nameForLabelHelp": "Алтернативно име за продуктовия етикет. Оставете празно, за да се използва името на съставката.",
    "namePlaceholder": "Въведете име на съставката…",
    "newIngredient": "Нова съставка",
    "noIngredients": "Няма намерени съставки",
    "notFound": "Съставката не е намерена",
    "nutrition": {
      "alcohol": "Алкохол",
      "carbohydrate": "Въглехидрати",
      "energy": "Енергийна стойност",
      "energyTooltip": "Автоматично изчислена от мазнини, въглехидрати, белтъчини и фибри",
      "fat": "Мазнини",
      "fibre": "Фибри",
      "importAction": "Импортиране",
      "importButton": "Импортиране от основни храни",
      "importDone": "Хранителните стойности са импортирани",
      "importedFrom": "Импортирано от: {{name}}",
      "importTitle": "Импорт на хранителни стойности",
      "perHundredGrams": "На 100 г",
      "perHundredGramsShort": "100 г",
      "perReference": "На {{quantity}} {{unit}}",
      "protein": "Белтъчини",
      "salt": "Сол",
      "saturatedFat": "от които наситени",
      "searchGenericIngredient": "Търсене в основни храни...",
      "searchNoResults": "Не са намерени съставки за \"{{query}}\"",
      "searchResultsCount_one": "Намерен {{count}} резултат",
      "searchResultsCount_other": "Намерени {{count}} резултата",
      "sugars": "от които захари",
      "sync": "Синхронизиране",
      "syncDone": "Хранителните стойности са синхронизирани",
      "unlink": "Премахване на връзката",
      "unlinkDone": "Връзката е премахната",
      "valuesPerLabel": "Хранителни стойности на"
    },
    "originalName": "Оригинално име",
    "parentOutdated": "Необходимо е обновяване",
    "photos": {
      "empty": "Все още няма снимки",
      "tooLarge": "Файлът е твърде голям (макс. 5 MB)",
      "upload": "Качване от компютър",
      "uploadFailed": "Качването на снимката неуспешно"
    },
    "price": {
      "changeButton": "Промяна на цена",
      "dialogTitle": "Цена на съставка",
      "empty": "Няма зададена цена",
      "inlineWithoutVat": "без ДДС",
      "inlineWithVat": "с ДДС",
      "noVat": "Без ДДС",
      "perKgWithoutVat": "За килограм (без ДДС)",
      "perKgWithVat": "За килограм (с ДДС)",
      "price": "Цена",
      "priceRequired": "Моля, въведете цена",
      "priceSummary": "{{price}} ({{vat}}) за {{quantity}}",
      "quantity": "Количество",
      "quantityRequired": "Моля, въведете количество",
      "removeButton": "Премахване на цена",
      "removeDone": "Цената е премахната",
      "saveDone": "Цената е запазена",
      "setButton": "Задаване на цена",
      "vatPresetLabel": "ДДС {{rate}}%",
      "vatRate": "Ставка на ДДС",
      "withoutVat": "Без ДДС",
      "withVat": "С ДДС"
    },
    "restore": "Възстановяване",
    "restoreConfirm": "Възстановяване на съставката? Ще може отново да се редактира.",
    "restoredDone": "Съставката е възстановена",
    "restoreTitle": "Възстановяване на съставка",
    "save": "Запазване",
    "searchPlaceholder": "Търсене на съставки…",
    "source": "Източник",
    "sourceData": "Данни от източника",
    "sourceId": "Идентификатор",
    "sources": {
      "CNF": "Canadian Nutrient File (CNF)",
      "COFID": "McCance and Widdowson's composition of foods integrated dataset (CoFID)"
    },
    "tabGeneral": "Основни",
    "tabLabel": "Етикет",
    "tabLabelIngredients_one": "Съставки ({{count}})",
    "tabLabelIngredients_other": "Съставки ({{count}})",
    "tabNutrition": "Хранителна стойност",
    "tabPhotos_one": "Снимки ({{count}})",
    "tabPhotos_other": "Снимки ({{count}})",
    "tabPrice": "Цена",
    "tabUsedInRecipes_one": "Използва се в рецепти ({{count}})",
    "tabUsedInRecipes_other": "Използва се в рецепти ({{count}})",
    "title": "Съставки",
    "updatedAt": "Обновена",
    "usedInRecipesEmpty": "Тази съставка не се използва в нито една рецепта",
    "validation": {
      "nameRequired": "Моля, въведете наименование"
    }
  },
  "landing": {
    "comingSoon": "Очаквайте скоро",
    "features": {
      "mealPlanning": {
        "description": "Планирайте седмичното си меню, генерирайте списъци за пазаруване и останете организирани в кухнята.",
        "title": "Планиране на менюто"
      },
      "nutrition": {
        "description": "Автоматично изчисляване на хранителните стойности за вашите рецепти на база съставки и порции.",
        "title": "Калкулатор за хранителни стойности"
      },
      "purchases": {
        "description": "Проследявайте покупките на съставки, следете цените и планирайте пазаруването ефективно.",
        "title": "Проследяване на покупки"
      },
      "qrLabels": {
        "description": "Генерирайте етикети с QR код, водещи към рецепти, хранителна информация или персонализирано съдържание.",
        "title": "Етикети с QR код"
      },
      "recipes": {
        "description": "Съхранявайте, организирайте и търсете всичките си рецепти на едно място. Никога повече не губете любима рецепта.",
        "title": "Управление на рецепти"
      },
      "wineLabels": {
        "description": "Проектирайте и печатайте професионални етикети за вашите домашни вина и напитки.",
        "title": "Етикети за вино"
      }
    },
    "featuresTitle": "Всичко, от което се нуждаете",
    "footer": "© 2026 Calculabel. Всички права запазени.",
    "getStarted": "Започнете",
    "getStartedFree": "Започнете безплатно",
    "heroSubtitle": "Управлявайте рецепти, изчислявайте хранителни стойности, проследявайте покупки на съставки, създавайте етикети за вино и генерирайте етикети с QR код — всичко на едно място.",
    "heroTitle": "Вашата кухня, организирана",
    "navFeatures": "Функции",
    "navPricing": "Цени",
    "openApp": "Към приложението",
    "pricingSubtitle": "Всички възможности са включени. Платете месечно или спестете при годишно плащане. Започнете 14-дневен безплатен период — без кредитна карта.",
    "pricingTitle": "Просто и прозрачно ценообразуване",
    "signIn": "Вход"
  },
  "layout": {
    "ingredients": "Съставки",
    "myAccount": "Моят профил",
    "producers": "Производители",
    "recipes": "Рецепти",
    "signOut": "Изход",
    "signOutConfirm": "Сигурни ли сте, че искате да излезете от профила?",
    "signOutTitle": "Изход от профила"
  },
  "login": {
    "checkInboxSubtitle": "Изпратихме линк за вход на",
    "checkInboxTitle": "Проверете пощата си",
    "consentLine": "С натискането на бутона <strong>{{button}}</strong> приемате <termsLink>Условията за ползване</termsLink> и <privacyLink>Политиката за поверителност</privacyLink>.",
    "invitationOnlyNote": "В момента Calculabel работи само с покани. За създаване на нов профил Ви е необходим линк за покана от съществуващ екип — съществуващи потребители могат да влязат по-долу.",
    "sendLink": "Изпращане на линк за вход",
    "subtitle": "Въведете имейла си и ще Ви изпратим линк за вход. Без парола.",
    "title": "Вход в Calculabel",
    "useDifferentEmail": "Използване на друг имейл",
    "validation": {
      "emailInvalid": "Моля, въведете валиден имейл",
      "emailRequired": "Моля, въведете имейл"
    }
  },
  "myAccount": {
    "emailHelp": "Имейлът е заключен на адреса, с който се регистрирахте. Свържете се с поддръжката, за да го промените.",
    "fullName": "Пълно име",
    "profileTab": "Профил",
    "profileUpdated": "Профилът е актуализиран успешно",
    "saveChanges": "Запазване",
    "teamTab": "Екип",
    "title": "Моят профил",
    "validation": {
      "nameRequired": "Името е задължително"
    }
  },
  "nutrition": {
    "declaration": {
      "carbohydrate": "въглехидрати",
      "energy": "енергийна стойност",
      "fat": "мазнини",
      "fibre": "фибри",
      "header": "Хранителна стойност за 100g:",
      "protein": "белтъци",
      "salt": "сол",
      "saturatedFat": "от които наситени мастни киселини",
      "sugars": "от които захари"
    }
  },
  "offline": {
    "restored": "Връзката с интернет е възстановена",
    "title": "Няма връзка с интернет. Моля, проверете връзката си."
  },
  "phone": {
    "delete": "Изтриване",
    "deleteAll": "Изтриване на всички",
    "deleteAllConfirm": "Сигурни ли сте, че искате да изтриете всички качени снимки?",
    "deleteAllTitle": "Изтриване на всички",
    "deleteConfirm": "Сигурни ли сте, че искате да изтриете тази снимка?",
    "deleteTitle": "Изтриване на снимка",
    "hint": "Тези снимки са достъпни в настолното приложение навсякъде, където може да качвате снимки.",
    "modalButton": "Направи снимка",
    "modalHint": "Сканирайте този QR код с телефона си, за да качите снимки директно от камерата.",
    "modalTitle": "Качване от телефон",
    "noPhotos": "Качените снимки от телефона ще се появят тук",
    "notLoggedIn": "Моля, сканирайте QR кода отново",
    "recentPhotos": "Последно качени снимки",
    "select": "Използване",
    "upload": "Направи снимка",
    "uploadFailed": "Качването неуспешно",
    "uploading": "Качване"
  },
  "pricing": {
    "annual": {
      "description": "Най-добра цена на месец, с едно плащане годишно.",
      "monthlyEquivalent": "{{amount}} / месец, таксувано годишно",
      "name": "Годишен абонамент"
    },
    "feature": {
      "labelGeneration": "Етикети с информация за хранителната стойност съгласно ЕС",
      "support": "Поддръжка по имейл",
      "teamMembers": "Неограничен брой членове на екипа",
      "unlimitedIngredients": "Неограничен брой съставки",
      "unlimitedRecipes": "Неограничен брой рецепти"
    },
    "intervalMonth": "/месец",
    "intervalYear": "/година",
    "monthly": {
      "description": "Максимална гъвкавост, без дългосрочен ангажимент.",
      "name": "Месечен абонамент"
    },
    "savingsBadge": "Спестявате {{amount}}",
    "startTrial": "Започване на 14-дневен безплатен период",
    "stripeNote": "Calculabel използва Stripe за сигурна обработка на плащанията и управление на абонаментите. Данните на Вашата карта се съхраняват и обработват от Stripe — те никога не достигат до нашите сървъри.",
    "taxBehavior": {
      "exclusive": "Цената е без ДДС или други данъци.",
      "inclusive": "С включено ДДС",
      "unspecified": ""
    }
  },
  "producers": {
    "actions": "Действия",
    "address": "Адрес",
    "companyName": "Име на фирмата",
    "createdAt": "Създаден",
    "createProducer": "Нов производител",
    "delete": "Изтриване",
    "deleteConfirm": "Сигурни ли сте, че искате да изтриете този производител?",
    "deletedBanner": "Този производител е изтрит.",
    "deletedDone": "Производителят е изтрит",
    "deleteTitle": "Изтриване на производител",
    "edit": "Редактиране",
    "email": "Имейл",
    "namePlaceholder": "Въведете име на фирмата",
    "newProducer": "Нов производител",
    "noProducers": "Все още няма производители",
    "notFound": "Производителят не е намерен",
    "phone": "Телефон",
    "restore": "Възстановяване",
    "restoreConfirm": "Сигурни ли сте, че искате да възстановите този производител?",
    "restoredDone": "Производителят е възстановен",
    "restoreTitle": "Възстановяване на производител",
    "save": "Запазване",
    "saved": "Данните за производителя са запазени",
    "searchPlaceholder": "Търсене на производители…",
    "tabGeneral": "Основни",
    "tabUsedInRecipes_one": "Рецепти ({{count}})",
    "tabUsedInRecipes_other": "Рецепти ({{count}})",
    "title": "Производители",
    "updatedAt": "Обновен",
    "usedInRecipesEmpty": "Няма рецепти с този производител",
    "validation": {
      "companyNameRequired": "Името на фирмата е задължително",
      "emailInvalid": "Моля, въведете валиден имейл"
    },
    "website": "Уебсайт"
  },
  "recipes": {
    "actions": "Действия",
    "addIngredient": "Добавяне на съставка",
    "addIngredientDone": "Съставката е добавена",
    "addIngredientTitle": "Добавяне на съставка",
    "allergens": "Алергени",
    "allergensHelp": "Допълнителни алергени, които не са част от съставките, но желаете да декларирате",
    "allergensPlaceholder": "Изберете алергени…",
    "archivedVersionBannerAction": "Вижте актуалната рецепта",
    "archivedVersionBannerText": "Това е стар вариант на тази рецепта.",
    "continueEditing": "Продължаване на редактиране",
    "costBreakdown": {
      "per100g": "За 100 g",
      "perKg": "За 1 kg",
      "perPackage": "За опаковка",
      "perServing": "За порция",
      "title": "Цена себестойност",
      "tooltip": "Подробности за цената",
      "total": "Цена на рецептата"
    },
    "createAndAdd": "Създаване и добавяне",
    "createAndReplace": "Създаване и замяна",
    "createdAt": "Създадена",
    "createRecipe": "Нова рецепта",
    "delete": "Изтриване",
    "deleteConfirm": "Сигурни ли сте, че искате да изтриете тази рецепта?",
    "deletedBanner": "Тази рецепта е изтрита.",
    "deletedDone": "Рецептата е изтрита",
    "deleteTitle": "Изтриване на рецепта",
    "description": "Описание",
    "discardDraft": "Отхвърляне",
    "discardDraftConfirm": "Сигурни ли сте, че искате да отхвърлите направените промени?",
    "discardDraftTitle": "Отхвърляне на промени",
    "draftBannerText": "Тази рецепта има непубликувани промени.",
    "duplicate": "Дублиране",
    "duplicatedDone": "Рецептата е дублирана",
    "duplicateNameSuffix": "(копие)",
    "duplicateTitle": "Дублиране на рецепта",
    "edit": "Редактиране",
    "ingredientDeletedTooltip": "Тази съставка е изтрита след като е била добавена в тази рецепта",
    "ingredientName": "Съставка",
    "ingredientOutdated": "Остаряла",
    "ingredientOutdatedTooltip": "Тази съставка е обновена след като е била добавена в тази рецепта",
    "ingredientTypes": {
      "GenericIngredient": "Основни храни",
      "IngredientRecipeIngredient": "Съставка",
      "SubRecipeRecipeIngredient": "Подрецепта"
    },
    "ingredientUpToDate": "Актуална",
    "label": {
      "export": "Експорт на етикет",
      "noIngredients": "Все още няма добавени съставки",
      "uppercaseAllergens": "Отбележи алергените с главни букви"
    },
    "name": "Име",
    "nameForLabel": "Име за етикет",
    "nameForLabelHelp": "Алтернативно име за продуктовия етикет. Оставете празно, за да се използва името на рецептата.",
    "namePlaceholder": "Въведете име на рецептата…",
    "netWeight": "Нето тегло на опаковка",
    "newRecipe": "Нова рецепта",
    "noIngredients": "Тази рецепта няма съставки",
    "noRecipes": "Няма намерени рецепти",
    "notFound": "Рецептата не е намерена",
    "nutrition": {
      "carbohydrate": "Въглехидрати",
      "energy": "Енергийна стойност",
      "fat": "Мазнини",
      "fibre": "Фибри",
      "noData": "Няма данни за хранителна стойност. Добавете съставки за изчисляване.",
      "perHundredGrams": "На 100 г",
      "perPackage": "На опаковка ({{grams}} г)",
      "perServing": "На порция ({{grams}} г)",
      "protein": "Белтъци",
      "salt": "Сол",
      "saturatedFat": "от които наситени",
      "saturatedFatShort": "наситени",
      "sugars": "от които захари",
      "sugarsShort": "захари"
    },
    "openSubRecipeIngredients": "За промяна на цената на рецептата трябва да промените цените на съставките",
    "parentOutdated": "Необходимо е обновяване",
    "price": "Цена",
    "producer": "Производител",
    "producerPlaceholder": "Изберете производител…",
    "quantity": "Количество",
    "removeIngredient": "Премахване",
    "removeIngredientConfirm": "Сигурни ли сте, че искате да премахнете тази съставка?",
    "removeIngredientDone": "Съставката е премахната",
    "removeIngredientTitle": "Премахване на съставка",
    "replaceIngredient": "Замяна",
    "replaceIngredientDone": "Съставката е заменена",
    "replaceIngredientTitle": "Замяна на съставка",
    "restore": "Възстановяване",
    "restoreConfirm": "Възстановяване на рецептата? Ще може отново да се редактира.",
    "restoredDone": "Рецептата е възстановена",
    "restoreTitle": "Възстановяване на рецепта",
    "save": "Запазване",
    "searchIngredient": "Търсене на съставка…",
    "searchNoResults": "Няма намерени резултати за \"{{query}}\"",
    "searchPlaceholder": "Търсене на рецепти…",
    "servingSize": "Размер на порцията",
    "servingsPerPackage": "Порции в опаковка",
    "showPrices": "Цени",
    "showQuantityTooltip": "Показване на процент в етикета. Задължително, когато съставката е спомената в наименованието на продукта.",
    "sortByWeight": "Сортиране по тегло",
    "sortByWeightDone": "Съставките са сортирани по тегло",
    "storagePresets": {
      "ambient": "Да се съхранява при стайна температура.",
      "coolDry": "Да се съхранява на сухо и хладно място.",
      "coolDryDark": "Да се съхранява на сухо и хладно място, защитено от пряка слънчева светлина.",
      "frozen": "Да се съхранява във фризер при -18 °C. Размразен продукт не се замразява повторно.",
      "refrigerate": "Да се съхранява в хладилник при температура 0–4 °C.",
      "refrigerateOpened": "След отваряне да се съхранява в хладилник и да се консумира до 3 дни."
    },
    "storagePresetsLabel": "Шаблони",
    "storageRequirements": "Условия за съхранение",
    "tabGeneral": "Основни",
    "tabIngredients_one": "Съставки ({{count}})",
    "tabIngredients_other": "Съставки ({{count}})",
    "tabLabel": "Етикет",
    "tabNutrition": "Хранителна стойност",
    "tabPhotos_one": "Снимки ({{count}})",
    "tabPhotos_other": "Снимки ({{count}})",
    "tabUsedAsSubRecipe_one": "Използва се като подрецепта ({{count}})",
    "tabUsedAsSubRecipe_other": "Използва се като подрецепта ({{count}})",
    "title": "Рецепти",
    "total": "Общо",
    "updatedAt": "Обновена",
    "updateIngredientVersion": "Обновяване до последния вариант",
    "updateIngredientVersionDone": "Съставката е обновена до последния вариант",
    "usedAsSubRecipeEmpty": "Тази рецепта не се използва като подрецепта в други рецепти",
    "validation": {
      "nameRequired": "Името е задължително"
    },
    "weightAfterCooking": "Тегло след готвене",
    "withoutVat": "Без ДДС",
    "withVat": "С ДДС",
    "yield": "Добив"
  },
  "team": {
    "actionAdminOnly": "Само администратори могат да управляват членовете на екипа",
    "actionCannotActOnSelf": "Не можете да извършите това действие върху себе си",
    "actionLastAdmin": "Екипът трябва да има поне един администратор",
    "cancelInvitation": "Отказ на поканата",
    "cancelInvitationConfirm": "Да бъде ли отменена поканата за {{email}}?",
    "copyInviteLink": "Копиране на линка",
    "demoteToMember": "Промяна на ролята до член",
    "demoteToMemberConfirm": "Да бъде ли променена ролята на {{name}} до член?",
    "expiresAt": "Изтича",
    "invited": "Поканен {{email}}",
    "inviteLinkCopied": "Линкът е копиран в клипборда",
    "inviteMember": "Покана на член",
    "joinedAt": "Присъединил се",
    "memberRemoved": "{{name}} беше премахнат(а)",
    "members": "Членове",
    "noPendingInvitations": "Няма чакащи покани.",
    "pendingInvitations": "Чакащи покани",
    "promoteToAdmin": "Повишаване до администратор",
    "promoteToAdminConfirm": "Да бъде ли повишен(а) {{name}} до администратор?",
    "removeMember": "Премахване",
    "removeMemberConfirm": "Да бъде ли премахнат(а) {{name}} от екипа? Достъпът му за вход ще бъде блокиран, но създадените от него рецепти, съставки и производители остават към екипа — нищо не се изтрива.",
    "role": "Роля",
    "roleCapabilitiesAdmin": "Администраторите могат да канят, премахват и променят ролите на членовете. Имат пълен достъп до рецептите, съставките и производителите.",
    "roleCapabilitiesMember": "Членовете имат пълен достъп до рецептите, съставките и производителите, но не могат да управляват членството в екипа.",
    "roles": {
      "ADMIN": "Администратор",
      "MEMBER": "Член"
    },
    "roleUpdated": "Ролята е променена",
    "sendInvite": "Изпращане на покана",
    "settings": {
      "country": "Държава",
      "currency": "Валута",
      "saveDone": "Настройките са запазени",
      "title": "Настройки"
    },
    "validation": {
      "emailInvalid": "Моля, въведете валиден имейл",
      "emailRequired": "Моля, въведете имейл"
    }
  }
}
